import { render, staticRenderFns } from "./AdminNewsItem.vue?vue&type=template&id=e1a884ee&scoped=true&"
import script from "./AdminNewsItem.vue?vue&type=script&lang=js&"
export * from "./AdminNewsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a884ee",
  null
  
)

export default component.exports